<template>
  <v-app
    id="inspire"
    :style="{ background: $vuetify.theme.themes.light.background }"
  >
    <router-view />
    <app-toast />
  </v-app>
</template>
<script>
const CryptoJS = require("crypto-js");
import AppToast from "@/components/AppToast.vue";

export default {
  components: { AppToast },
  data() {
    return {
      isTabClosed: false,

      logoutTimer: null, // Timer for automatic logout
      inactivityDuration: 10 * 60 * 1000, // 10 minutes in milliseconds
    };
  },
  methods: {
    logout() {
      this.logOut();
      location.replace("/");
    },
    encryptIt(string) {
      let encrypted = CryptoJS.AES.encrypt(
        `${string}`,
        "secret key"
      ).toString();
      return encrypted;
    },
  },
};
</script>
<!-- Global styles now live in src/assets/styles/main.scss (imported once in main.js) -->
